import { selectLegacyIsInboxBootstrapped } from 'ducks/bootstrap/selectors/selectLegacyIsInboxBootstrapped'
import { createSelector } from 'reselect'

import {
  fetchingStatusesSelector,
  isAuthenticatedSelector,
  isBoostrappedSelector,
  isRealtimeSubscribedSelector,
  hasRealtimeConnectedOnceSelector,
} from 'selectors/app/base'
import {
  selectCurrentPath,
  selectIsInInbox,
  selectIsInChat,
} from 'selectors/location'
import { selectIsOnOnboardingPage } from 'subapps/onboarding/selectors'

export const selectIsInvalidPath = createSelector(
  selectCurrentPath,
  path => path === '/tickets' || path === '/tickets/'
)

export const shouldSubscribeToRealtimeSelector = createSelector(
  isAuthenticatedSelector,
  isBoostrappedSelector,
  isRealtimeSubscribedSelector,
  fetchingStatusesSelector,
  selectIsInChat,
  selectIsOnOnboardingPage,
  hasRealtimeConnectedOnceSelector,
  (
    authenticated,
    bootstrapped,
    subscribed,
    statuses,
    inChat,
    inOnboarding,
    hasConnectedOnce
  ) => {
    return (
      authenticated &&
      (bootstrapped || inChat) &&
      !inOnboarding &&
      !subscribed &&
      !statuses.subscribeRealtime &&
      !hasConnectedOnce
    )
  }
)

export const shouldFetchInboxBootstrapData = createSelector(
  isAuthenticatedSelector,
  fetchingStatusesSelector,
  selectIsInInbox,
  selectLegacyIsInboxBootstrapped,
  (authenticated, statuses, inInbox, isInboxBoostrapped) => {
    return (
      inInbox && authenticated && !isInboxBoostrapped && !statuses.fetchAppData
    )
  }
)
